// Enumeration describing the different types of transaction
export enum CollaborationPlatformTypeEnum {
    None = 0,
    Mine = 1,
    WuDo = 2,
    Club = 3,
}
